<template>
  <div class="standard-switch-container">
    <label v-if="label">
      {{ label }}
    </label>
    <input
      hidden
      type="checkbox"
      v-model="checkboxValue"
    >
    <div
      class="standard-switch-wrapper"
      @click="onClick()"
    >
      <div
        class="indicator"
        :class="{
          'active': checkboxValue,
        }"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      default: () => '',
      type: String,
    },
    initialState: {
      default: () => false,
      type: Boolean,
    },
  },
  data() {
    return {
      checkboxValue: false,
    };
  },
  methods: {
    onClick() {
      this.checkboxValue = !this.checkboxValue;
    },
  },
  watch: {
    checkboxValue(newVal) {
      this.$emit('switch_change', newVal);
    },
  },
  created() {
    this.checkboxValue = this.initialState;
  },
};
</script>
